import { knotsApiSdk } from '@/lib/fetcher'
import { Connector } from '@/features/connectors'

export const getConnectors = async (): Promise<Connector[]> => {
  return knotsApiSdk.listConnectors() as unknown as Connector[]
}
